import { createSelector } from '@reduxjs/toolkit';
import { QuoteVendorOrder } from './models';
import { baseApi } from '@centerpiece/components';

export const quote_vendor_order = baseApi
  .enhanceEndpoints({ addTagTypes: ['QuoteVendorOrders', 'QuoteVendorOrder'] })
  .injectEndpoints({
    endpoints: builder => ({
      getQuoteVendorOrders: builder.query<
        QuoteVendorOrder[],
        { params?: object }
      >({
        query: ({ params }: { params?: object }) => ({
          url: 'quote_vendor_order',
          method: 'GET',
          params: params,
        }),
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'QuoteVendorOrder' as const,
                  id,
                })),
                'QuoteVendorOrders',
              ]
            : ['QuoteVendorOrders'],
      }),
      getQuoteVendorOrder: builder.query<
        QuoteVendorOrder,
        { id: number; params?: object }
      >({
        query: ({ id, params }: { id: number; params?: object }) => {
          return {
            url: `quote_vendor_order/${id}`,
            method: 'GET',
            params: params,
          };
        },
        providesTags: (result, error, arg) => [
          { type: 'QuoteVendorOrder', id: arg.id },
        ],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 90,
      }),
      createQuoteVendorOrder: builder.mutation({
        query: request => ({
          url: 'quote_vendor_order',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: ['QuoteVendorOrders'],
      }),
      patchQuoteVendorOrder: builder.mutation<
        QuoteVendorOrder,
        QuoteVendorOrder
      >({
        query: request => ({
          url: `quote_vendor_order/${request.id}`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'QuoteVendorOrder', id: arg.id },
        ],
      }),
      updateQuoteVendorOrder: builder.mutation<
        QuoteVendorOrder,
        QuoteVendorOrder
      >({
        query: request => ({
          url: `quote_vendor_order/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'QuoteVendorOrder', id: arg.id },
        ],
      }),
      deleteQuoteVendorOrder: builder.mutation<QuoteVendorOrder, number>({
        query: id => ({
          url: `quote_vendor_order/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result
            ? [{ type: 'QuoteVendorOrder' as const, arg }, 'QuoteVendorOrders']
            : ['QuoteVendorOrders'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  useGetQuoteVendorOrdersQuery,
  useGetQuoteVendorOrderQuery,
  useCreateQuoteVendorOrderMutation,
  usePatchQuoteVendorOrderMutation,
  useUpdateQuoteVendorOrderMutation,
  useDeleteQuoteVendorOrderMutation,
  usePrefetch: useQuoteVendorOrdersPrefetch,
} = quote_vendor_order;
const selectQuoteVendorOrdersRoot =
  quote_vendor_order.endpoints.getQuoteVendorOrders.select({});
export const selectQuoteVendorOrders = createSelector(
  selectQuoteVendorOrdersRoot,
  quote_vendor_order => quote_vendor_order.data || []
);
